module.exports = __webpack_public_path__ + "static/media/tax.1bd50165.png";